import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { RecommendationModel } from 'projects/core/src/lib/models/recommendation.model';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { FormHelper } from '../../../../../../../shared/form-helper';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-recommendation-basedata',
  templateUrl: './recommendation-basedata.component.html',
  styleUrls: ['./recommendation-basedata.component.scss']
})
export class RecommendationBasedataComponent extends BaseForm implements OnInit, OnChanges {

  @Input() recommendation: RecommendationModel = null;
  @Output() setEdit = new EventEmitter<string>();

  public form = this.fb.group({
    name_de: new UntypedFormControl('', [Validators.required]),
    name_en: new UntypedFormControl('', [Validators.required])
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private confirmation: ConfirmationService,
    public transloco: TranslocoService
  ) {
    super();
   }

  ngOnInit(): void {
    this.ui.setFocus();
  }

  ngOnChanges(): void {
    this.items = [];
    if (this.recommendation !== null && this.auth.hasRight('admin.recommendation.delete')) {
      this.items.push({
        label: this.transloco.translate('common.labels.delete'),
        icon: 'pi pi-trash',
        styleClass: 'danger-button',
        disabled: (!this.recommendation.deletable),
        command: () => {
          this.onDelete();
        }
      });
    }
  }

  onEdit(): void {
    if (this.auth.hasRight('admin.recommendation.edit')) {
      this.startEdit();
    }
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      this.api.saveModel('recommendations', this.recommendation.id, this.form.value).subscribe({
        next: (result: any) => {
          this.recommendation.deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: this.recommendation.getLang('name', this.transloco.getActiveLang()) }), this.transloco.translate('common.saved'));
          this.stopEdit();
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  onDelete(): void {
    if (this.auth.hasRight('admin.recommendation.delete')) {
      this.confirmation.confirm({
        message: this.transloco.translate('common.messages.really_delete', { value: this.recommendation.getLang('name', this.transloco.getActiveLang()) }),
        header: this.transloco.translate('common.really_delete'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.api.deleteModel('recommendations', this.recommendation.id).subscribe({
            next: () => {
              this.ui.toastSuccess(this.transloco.translate('common.messages.deleted', { value: this.recommendation.getLang('name', this.transloco.getActiveLang()) }), this.transloco.translate('common.deleted'));
              this.router.navigate(['/recommendations']);
            },
            error: (error: any) => {
              this.ui.toastError(this.transloco.translate(error.message));
            }
          });
        }
      });
    }
  }

  protected startEdit(): void {
    if (this.recommendation !== null) {
      this.form.patchValue({
        name_de: this.recommendation.getLang('name', 'DE'),
        name_en: this.recommendation.getLang('name', 'EN')
      });
    }
    this.setEdit.emit('basedata');
    super.startEdit();
    this.ui.setFormFocus();
  }

  protected stopEdit(): void {
    this.setEdit.emit(null);
    super.stopEdit();
    this.ui.setFocus();
  }

}
